import BaseModel from 'volta/models/base-model';
import { sanitized } from 'volta/utils/text-utils';

import { attr } from '@ember-data/model';
import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';

import type { IResourceName } from 'volta/models/base-model';

import type { TRouteType } from 'volta/models/types/route-operation';
import type IntlService from 'ember-intl/services/intl';

export const RouteOperationResourceName: IResourceName = {
  singular: 'route',
  plural: 'routes'
};

export default class Route extends BaseModel {
  @service intl!: IntlService;

  @attr('string') manufacturedSkuId!: string;
  @attr('string') code!: string;
  @attr('string') routeType!: TRouteType;
  @attr('boolean') isActive!: boolean;

  @cached
  get searchName() {
    return sanitized(this.code);
  }

  [Type] = 'route' as const;
}
